export const COLUMNS = [
  {
    Header: "FundTap Quote Id",
    accessor: "fundTapQuoteId"
  },
  {
    Header: "Status",
    accessor: "status"
  },
  {
    Header: "Xero Status",
    accessor: "xeroStatus"
  },
  {
    Header: "Invoice Number",
    accessor: "invoiceNumber"
  },
  {
    Header: "Date Funded",
    accessor: "dateFunded"
  },
  {
    Header: "Customer",
    accessor: "customer"
  },
  {
    Header: "Debtor",
    accessor: "debtor"
  },
  {
    Header: "Inv Funded",
    accessor: "invFunded",
    Cell: ({ value }) => `$${Number(value).toFixed(2)}`
  },
  {
    Header: "Fee Today",
    accessor: "invoiceFee",
    Cell: ({ value }) => `$${Number(value).toFixed(2)}`
  },
  {
    Header: "Amount Due",
    accessor: "amountDue",
    Cell: ({ value }) => `$${Number(value).toFixed(2)}`
  },
  {
    Header: "Due Date",
    accessor: "dueDate"
  },
  {
    Header: "Date In",
    accessor: "dueIn"
  },
  {
    Header: "Date Completed",
    accessor: "dateCompleted"
  }
];
